<template>
  <div class="deactivate-btn">
    <el-dropdown @command="changeDropHandle">
      <el-button type="primary">
        {{ localActiveMes }}<i class="el-icon-arrow-down el-icon--right"></i>
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item :command="active_mes">{{ active_mes }}</el-dropdown-item>
        <el-dropdown-item command="Delete">Delete</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  name: 'raSelectButton',
  props: {
    active_mes: {
      type: String,
      default: 'Deactivate'
    }
  },
  data() {
    return {
      localActiveMes: this.active_mes, // 使用一个本地数据属性
      showDropdown: false,
    }
  },
  methods: {
    changeDropHandle(e) {
      console.log(e,'ddd')
        this.localActiveMes = e; // 更新本地数据
      console.log(this.localActiveMes);
      this.$emit('changeDropHandle', this.localActiveMes);
    }
  },
  watch: {
    active_mes(newVal) {
      this.localActiveMes = newVal; // 监听 prop 的变化
    }
  }
}
</script>

<style lang="less" scoped>
.deactivate-btn {
  /deep/ .el-button {
    background-color: #ff6347 !important;
    color: #fff;
    border: none;
    padding: 8px 16px !important;
    border-radius: 20px;
    font-size: 14px;
    cursor: pointer;
    display: flex;
    align-items: center;
    font-weight: bold;
  }

  .dropdown-menu {
    position: absolute;
    top: 40px;
    background-color: #fff;
    border: 1px solid #ff6347;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    padding: 8px 0;
    z-index: 1;
    border-radius: 16px;

    .dropdown-item {
      color: #ff6347;
      padding: 8px 16px;
      cursor: pointer;
      text-align: left;
      font-weight: normal;

      &:hover {
        font-weight: bold;
      }
    }
  }
}
</style>
